<template>
  <div class='footer-wrapper'>
    <div class="container">
      <div class='footer-info paragraph-s'>
        <div class='mb-m footer-title'>
          Контакти:
        </div>
        <div class='footer-contacts-item mb-m'>
          <div class='d-flex align-items-center mr-s'>
            <v-icon name="envelope" class='d-flex text-primary'></v-icon>
          </div>
          <span class='mr-s'>Email:</span>
          <a href="mailto:info@musichenko.com" class="app-link">info@musichenko.com</a>
        </div>
        <div class='footer-contacts-item mb-m'>
          <div class='d-flex align-items-center mr-s'>
            <v-icon name="phone" class='d-flex text-primary'></v-icon>
          </div>
          <span class='mr-s'>Телефон:</span>
          <a href="tel:+380672707941" class="app-link">+380672707941</a>
        </div>
        <div class='footer-contacts-item'>
          <div class='d-flex align-items-center mr-s'>
            <v-icon name="map-marker-alt" class='d-flex text-primary mr-s'></v-icon>
          </div>
          <span class='mr-s'>Адреса:</span>
          <a href='https://g.page/musichenko?share' target="_blank" class='app-link'>Оріхівське шосе 10, Запоріжжя</a>
        </div>
      </div>
      <div class='other-info paragraph-s'>
        <div class='mb-m footer-title'>
          Розробник:
        </div>
        <div class='footer-contacts-item'>
          <div class='d-flex align-items-center mr-s'>
            <v-icon name="user" class='d-flex text-primary mr-s'></v-icon>
          </div>
          <span class='mr-s'>LinkedIn:</span>
          <a href='https://www.linkedin.com/in/zicrael' target="_blank" class='app-link'>Yaroslav Kikot</a>
        </div>
      </div>
      <div class='copyright'>
        © {{ currentYear }} Musichenko
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  computed: {
    currentYear () {
      return new Date().getFullYear()
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'src/styles/_colors.scss';
@import 'src/styles/_sizes.scss';

.footer-wrapper {
  padding-top: 50px;
  padding-bottom: 50px;
  border-top: 2px solid $primary-color;
  position: relative;

  .container {
    justify-content: flex-start;
    display: flex;

    .footer-info {
      margin-right: 30px;
    }

    .footer-contacts-item {
      display: flex;
      align-items: center;
    }

    .copyright {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      padding: 5px 5px 20px 5px;
      text-align: center;
      color: $asset-color;
      opacity: 0.5;
    }
  }
}

@media(max-width: $mobile) {
  .footer-wrapper {
    .container {
      justify-content: flex-start;
      display: flex;
      flex-direction: column;

      .footer-info {
        margin-right: 0;
        margin-bottom: 15px;
      }
    }
  }
}
</style>
